import React, { useEffect, useState } from 'react';

import InputLabelWrapper from 'components/basic/input-label-wrapper/InputLabelWrapper';
import { easasAlert } from 'components/fragments/easas-global-fragment/EasasGlobalAlerts';
import { Attribute, MdmProjectInputInput, useGetProjectQuery, useUpdateProjectMutation } from 'gql/generated/types';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { TabPanel, TabView } from 'primereact/tabview';
import { useOutletContext } from 'react-router-dom';
import AdditionalProjectSettings from '../components/AdditionalProjectSettings';

const Settings = () => {
  const [projectConfig, setProjectConfig] = useState<MdmProjectInputInput | null>(null);
  const [objAttributes, setObjAttributes] = useState<Attribute[]>([]);
  const [deviceAttributes, setDeviceAttributes] = useState<Attribute[]>([]);

  const projectId = useOutletContext<string>();

  const { data } = useGetProjectQuery({ variables: { id: projectId }, skip: !projectId });

  const [mutateFunction] = useUpdateProjectMutation({
    onCompleted: () => {
      easasAlert({
        severity: "success",
        summary: "Success",
        detail: "Project updated successfully",
        life: 3000,
      });
    },
    onError: err => {
      easasAlert({ severity: "error", summary: "Error", detail: err.message, life: 3000 });
    },
    refetchQueries: ["GetProject"],
  });

  useEffect(() => {
    if (data) {
      setProjectConfig(data.mdmProjectById as MdmProjectInputInput);
      setObjAttributes((data.mdmProjectById?.configuration?.objectConfiguration?.customFields ?? []) as Attribute[]);
      setDeviceAttributes((data.mdmProjectById?.configuration?.deviceConfiguration?.customFields ?? []) as Attribute[]);
    }
  }, [data]);

  const handleSubmit = () => {
    const project: MdmProjectInputInput = {
      ...projectConfig,
      configuration: {
        ...projectConfig?.configuration,
        analyticsConfiguration: {
          ...projectConfig!.configuration!.analyticsConfiguration,
        },
        deviceConfiguration: {
          ...projectConfig!.configuration!.deviceConfiguration,
          customFields: deviceAttributes,
        },
        objectConfiguration: {
          ...projectConfig!.configuration!.objectConfiguration,
          customFields: objAttributes,
        },
      },
    };
    mutateFunction({ variables: { project } })
  }

  return (
    <div className="grid p-fluid m-3 w-full mx-auto">
      <InputLabelWrapper labelName="Project">
        <InputText
          value={projectConfig?.title ?? ""}
          type="text"
          placeholder="Project name"
          onChange={e => setProjectConfig(prev => ({ ...prev, title: e.target.value }))}
        />
      </InputLabelWrapper>
      <div className="flex w-full justify-content-end gap-3">
        <Button
          type="submit"
          onClick={handleSubmit}
          label="Update"
          className="p-button-rounded p-button-primary w-10rem"
        />
      </div>

      <TabView className="col-12">
        <TabPanel header="Objects">
          <AdditionalProjectSettings attributes={objAttributes} setAttributes={setObjAttributes} />
        </TabPanel>
        <TabPanel header="Device">
          <AdditionalProjectSettings attributes={deviceAttributes} setAttributes={setDeviceAttributes} />
        </TabPanel>
      </TabView>
    </div>
  );
}

export default Settings;
